export const authRoutes = (apiBase) => ({
  login: `${apiBase}/auth/login`,
  me: `${apiBase}/auth/me`,
  refresh: `${apiBase}/auth/refresh`,
  logout: `${apiBase}/auth/logout`,
});
